import { SubscriptionsApiService } from "../api/SubscriptionsService";
import { IResult } from "../models/results/result.interface";
import { b64ToBlob } from "../utils/fileUtil";
import logger from "../utils/logger";

export type GetPrescriptionPdfByTokenParams = {
    pdfToken: string;
    authToken: string;
};

const downloadPrescriptionPdfByToken = async ({
    pdfToken,
    authToken,
}: GetPrescriptionPdfByTokenParams): Promise<IResult<Blob>> => {
    logger.info(downloadPrescriptionPdfByToken.name, "Getting prescription PDF by token");

    try {
        const { response: resp, error } = await SubscriptionsApiService.ecgsGetPrescriptionPdfByToken(
            {
                prescriptionDto: { token: pdfToken }, authorization: `Bearer ${authToken}`
            }
        );

        if (error || !resp || !resp.prescriptionPdfBytes) {
            logger.error(downloadPrescriptionPdfByToken.name, "Invalid API response", {
                resp,
                error,
            });

            return {
                success: false,
                message: error?.errorMessage,
                errorCode: error?.errorCode?.toString(),
            };
        }

        const file = b64ToBlob(resp.prescriptionPdfBytes, "application/pdf");

        return {
            success: true,
            data: file,
        };
    } catch (error) {
        logger.error(downloadPrescriptionPdfByToken.name, "Error Getting prescription.", error);
        return {
            success: false,
            message: (error as Error).message,
        };
    }
};

const subscriptionsService = {
    downloadPrescriptionPdfByToken,
};

export default subscriptionsService;
